import GoalForm from './GoalForm';

export default GoalForm;
